import React from "react";

interface Props {
  activeColor: string;
}
const DownloadIcon: React.FC<Props> = ({ activeColor = "#4fd5f2" }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8415 7.3L12.5566 5.96C12.3456 5.74 12.0028 5.74 11.7919 5.96L8.51249 9.38V0.565C8.51249 0.255 8.27037 0 7.97072 0H5.80604C5.50639 0 5.26427 0.2525 5.26427 0.565V9.1475L2.20783 5.96C1.99687 5.74 1.65407 5.74 1.44312 5.96L0.158216 7.3C-0.0527386 7.52 -0.0527386 7.8775 0.158216 8.0975L6.61869 14.835C6.82965 15.055 7.17245 15.055 7.3834 14.835L13.8439 8.0975C14.0524 7.8775 14.0524 7.52 13.8415 7.3Z"
        fill={activeColor}
      />
    </svg>
  );
};

export default DownloadIcon;
